export default __webpack_public_path__ + "static/media/ljubeznost-logo-100-sb.37cf8ba7.png";